import { render } from "./ClientDeauthorizeJwtBearerModal.vue?vue&type=template&id=7b9af72e"
import script from "./ClientDeauthorizeJwtBearerModal.vue?vue&type=script&lang=js"
export * from "./ClientDeauthorizeJwtBearerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__